import React from 'react'
import {convertDate, stringToHML, convertDateTime} from './generalfunctions.jsx'

const Produkte = (props) => {

    function produkt_lektionenRow(pl){
            
        const moveBtn = null

        const btnsEdit = <><button onClick={()=>props.editProdukt(pl)}   className="btn-sm-round btn-secondary"><i className="material-icons"> edit </i></button> <button className="btn-sm-round btn-info" onClick={()=>props.deleteProdukt(pl)}><i className="material-icons"> close </i></button>  {moveBtn}</>

        let thumb = null
        if (pl.cover_image !== ""){
            let src=`/media/albumthumbs/${pl.cover_image}`
            thumb = <img  src={src} width="50" />
        }
        if (pl.standardcover===1){
            thumb = <img src="/media/albumthumbs/albumthumbnail.png" width="50" />
            if (pl.ist_technische_uebung ===1)thumb = <img src="/media/albumthumbs/guitarexercise.png" width="50" />
        }
        return(
            <tr>
                <td width={50}>{thumb}</td>
                <td width={300}>{stringToHML(pl.thema)}</td>
                <td>{btnsEdit}</td>
            </tr>
        )

    }


    return(
        <section className="cid-r8R4yMgBSy mbr-fullscreen mbr-parallax-background" id="header1-5" style={{backgroundImage: 'url(../../../assets/images/about5.png)'}}>
        <div className="container text-center" data-stellar-background-ratio=".5">
            <div className="row slider-wrapper" style={{backgroundColor:'white', borderRadius:'30px', padding:'20px'}}>
                <div className="col-md-12" style={{minHeight:'900px'}}>                    
                    <h4>Produkte</h4>
                    <button className="btn btn-primary" onClick={props.neuesProdukt}>Neu + </button>
                    <table className="table">
                        <tbody>                            
                            {props.produkt_lektionen.map(produkt_lektionenRow)}
                        </tbody>
                    </table>
                    
                </div>
            </div>
        </div>
    </section>
    )



}

export default Produkte